module.exports = __webpack_public_path__ + "img/arla.f65ef19d.svg";